export const translation = {
  "connecting": "Verbinden...",
  "offline": {
    "title": "Tut uns leid!",
    "message": "Momentan findet kein Quiz statt"
  },
  "video": {
    "tapToUnmute": "Stummschaltung aufheben",
    "tryVideoAgain": "Video erneut versuchen"
  },
  "countdown": {
    "soon": "In Kürze",
    "aboutToStart": "Gleich geht‘s los...",
    "kickOff": "Start"
  },
  "join": {
    "instruction": "Nimm am Quiz teil!",
    "joinInNow": "Jetzt mitmachen!",
    "screenName": "Nickname",
    "enterScreenName": "Gib hier deinen Namen ein!",
    "button": {
      "join": "Teilnehmen",
      "next": "Weiter"
    },
    "chooseTeam": "Wähle dein Team",
    "hello": "Hallo",
    "vs": "– vs –",
    "player": "Spieler",
    "players": "Spieler"
  },
  "form": {
    "name": "Name",
    "email": "Email",
    "mobile": "Telefonnummer",
    "iAgreeToThe": "Hiermit stimme ich den <0>{{terms}}</0> zu",
    "terms": "Teilnahmebedingungen",
    "termsLink": "https://piing.events/terms-quiiz",
    "privacyPolicy": "Datenschutz-Bestimmungen",
    "privacyPolicies": "Datenschutzrichtlinien",
    "privacyLink": "https://piing.events/privacy",
    "ok": "OK"
  },
  "errorBoundary": {
    "connectionErrorTitle": "Entschuldigung, wir hatten Probleme, Sie zu verbinden.",
    "connectionError": "Bitte <0>{{tryAgain1}}</0>.",
    "notConnectionErrorTitle": "Entschuldigung, etwas ist schief gelaufen.",
    "notConnectionError": "Bitte <0>{{tryAgain2}}</0> oder <1>{{contactUs}}</1>, um dieses Problem zu melden.",
    "tryAgain1": "versuche es erneut",
    "tryAgain2": "versuchen Sie es erneut",
    "contactUs": "kontaktieren Sie unss",
    "emailSubject": "Melden Sie ein Problem mit Quiiz",
    "emailBody": "Bitte beschreiben Sie unten, was passiert ist"
  },
  "validation": {
    "nameTaken": "Dieser Name ist leider schon vergeben!",
    "problemJoining": "Es gab ein Problem beim Beitritt zum Quiz! ",
    "notReadyForPlayers": "Das Quiz ist noch nicht bereit für Spieler",
    "checkName": "Bitte trage deinen Namen ein",
    "checkEmail": "Bitte trage deine Emailadresse ein",
    "checkMobile": "Bitte trage deine Telefonnummer ein",
  },
  "leaderboard": {
    "teamsLeaderboard": "Team Rangliste",
    "playersLeaderboard": "Rangliste",
    "team": "Team",
    "name": "name",
    "score": "Punkte",
    "bonus": "Bonus",
    "wins": "hat gewonnen!",
    "tab": {
      "topPlayers": "Beste Spieler",
      "topTeams": "Beste Teams",
      "yourTeam": "Dein Team",
    }
  },
  "score": {
    "q": "Frage ",
    "correct": "Richtig",
    "incorrect": "Falsch",
    "speedBonus": "Speed bonus",
    "team": "Team",
    "overall": "Insgesamt",
    "score": "Punktestand",
    "rank": "Rang",
  },
  "question": {
    "question": "Frage",
    "milliseconds": "ms",
  }
};